import React from 'react';
import FuturesTrade from './FuturesTrade';
import { useNavigate, useParams } from 'react-router-dom';
import { useContextData } from '../core/context';
import FuturesTradeTemp from './FuturesTradeTemp';

const FuturesTradeWrap = () => {
    const { pairName } = useParams();
    const navigate = useNavigate();
    const { myProfile } = useContextData();

    const handleNavigation = (newSymbol) => {
        // setOrderBookData(null);
        // popupState.close();
        navigate('/futures/trade/' + newSymbol);
    };
    return (
        <div>
            <h1 className='visually-hidden'>Futures Trade</h1>
            {
                (myProfile && myProfile?._id === '6402c9566abd01d9e3e72841') ? <FuturesTradeTemp handleNavigation={handleNavigation} key={pairName} pairName={pairName} navigate={navigate} /> : <FuturesTrade handleNavigation={handleNavigation} key={pairName} pairName={pairName} navigate={navigate} />
            }
        </div>
    );
};

export default FuturesTradeWrap;